import axios from '../utils/axios';
import { SUB_SYSTEM_NAME } from '../utils/constants';

/**
 * 
 * @param {*} param0 
 * @returns 
 */
 export const getEncryptedData = ({ reqBody =[]}) => {
    return axios({
      method: 'POST',
      url: `/cubytsGeek/crypto/encrypt/`,
      data: reqBody,
    });
  };
/**
 * 
 * @param {*} param0 
 * @returns 
 */
 export const getDecryptedData = ( reqBody={}, token, captchaType = null) => {
    const headers = {
      'X-Recaptcha': token,
    };

    // Add captcha type header if specified (for reset password flow)
    if (captchaType) {
      headers['X-Captcha-Type'] = captchaType;
    }

    return axios({
      method: 'POST',
      url: `/cubytsGeek/crypto/decrypt/`,
      data: reqBody,
      subSystemName: SUB_SYSTEM_NAME.BYTS,
      headers,
    });
  };